import { PushNotificationProvider } from "@/models";
import appInsights from "@/utils/appInsights";
import { NativeAppType } from "./";
import { BaseNativeApp, CallNative, WebToNativeMethods } from "./baseNativeApp";

// Tell Typescript about the androidApp property the Android app puts on window
declare global {
  interface Window {
    androidApp?: NativeAndroid;
  }
}

export type NativeAndroid = Record<keyof WebToNativeMethods, (json: string) => void>;

export function isAndroid() {
  return !!window.androidApp;
}

// This represents the communication from Vue to the android app
export default class Android extends BaseNativeApp {
  readonly isMobile = true;
  readonly type = NativeAppType.Android;
  readonly deviceOS = "Android";
  readonly pushNotificationProvider = PushNotificationProvider.Firebase;

  readonly callNative: CallNative = (method, param) => {
    // appInsights.trackEvent({
    //   name: "Web -> NativeApp: " + method,
    //   properties: {
    //     type: this.deviceOS
    //   }
    // });

    // Android only supports sending native object types (e.g. string, number, boolean), so send the parameter as JSON
    window.androidApp?.[method](JSON.stringify(param));
  };
}
